import Vue from 'vue';
import VueApollo from 'vue-apollo';
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from '@apollo/client/core';
import {setContext} from '@apollo/client/link/context';
import {onError} from '@apollo/client/link/error';
import store from '@/Client/Store';

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint
const httpEndpoint = process.env.CORE_API_URL + '/api/graphql';

const authLink = setContext(async (_, {headers}) => {
  const token = store.state.user.token;
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const onErrorLink = onError(({graphQLErrors, networkError}) => {
  if (graphQLErrors) {
    graphQLErrors.map(({message, locations, path}) =>
      console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      ),
    );
  }
  if (networkError) {
    if (networkError.statusCode === 401) {
      store.dispatch('logout').then(() => {
        window.location.href = '/login';
      });
    }
    if (networkError.statusCode === 403) {
      store.dispatch('setForbiddenError', true);
    }
  }
});

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    authLink,
    onErrorLink,
    new HttpLink({uri: httpEndpoint}),
  ]),
  cache: new InMemoryCache(),
});

// Call this in the Vue app file
export function createProvider(options = {}) {
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: 'no-cache',
      },
    },
    errorHandler(error) {
      console.error('Error:', error.message);
    },
  });

  return apolloProvider;
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem('apollo-token', token);
  }
  try {
    await apolloClient.resetStore();
  } catch (e) {
    console.warn('Error on cache reset (login):', e.message);
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem('apollo-token');
  }
  try {
    await apolloClient.resetStore();
  } catch (e) {
    console.warn('Error on cache reset (logout):', e.message);
  }
}
